module.exports = __webpack_public_path__ + "img/icon-door.fcbffd9c.svg";